import { render } from "./AddKeyButton.vue?vue&type=template&id=1671e7ef&scoped=true&lang=pug"
import script from "./AddKeyButton.vue?vue&type=script&lang=js"
export * from "./AddKeyButton.vue?vue&type=script&lang=js"

import "./AddKeyButton.vue?vue&type=style&index=0&id=1671e7ef&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1671e7ef"]])

export default __exports__